import { Question } from '@phosphor-icons/react';

export const HELP_EVENT = 'sketchario:help';

export function openContextHelp(articleId) {
  if (!articleId) return;
  window.dispatchEvent(new CustomEvent(HELP_EVENT, { detail: { articleId } }));
}

export default function ContextHelpButton({ articleId, label = 'Apri guida relativa', className = '' }) {
  return (
    <button
      type="button"
      data-testid={`context-help-${articleId}`}
      className={`inline-flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border border-[var(--border-color)] bg-[var(--bg-card)] text-[var(--text-muted)] transition-colors hover:border-[var(--accent-purple)] hover:text-white ${className}`}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        openContextHelp(articleId);
      }}
      aria-label={label}
      title={label}
    >
      <Question size={13} weight="bold" />
    </button>
  );
}
